import { render } from "./OverviewLayout.vue?vue&type=template&id=0500a0ac"
import script from "./OverviewLayout.vue?vue&type=script&lang=js"
export * from "./OverviewLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__